import axios from 'axios';

const DEV = false;

if(DEV) {
  axios.defaults.baseURL = 'http://localhost:8888'
} else {
  axios.defaults.baseURL = 'http://api.allaboutyouns.com'
}

const GOOGLE_API_KEY = "AIzaSyACZtzqUIlztzEgO-Q1bMbxmlRaFUy0VVU"
const GOOGLE_PLACE_ID = "ChIJHSxeOLZnV0sRqbT8Yr4Pbeg"

//axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;

export { axios, GOOGLE_API_KEY, GOOGLE_PLACE_ID }


// WEBPACK FOOTER //
// ./src/config.js